export default "__VITE_ASSET__DpJEi7dh__"